import script from "./PermissionMg.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionMg.vue?vue&type=script&setup=true&lang=js"

import "./PermissionMg.vue?vue&type=style&index=0&id=5c0576b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c0576b8"]])

export default __exports__